import React, { useEffect, useLayoutEffect, useState } from "react";
import "./StatusBoardTable.scss";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as _ from "lodash";
import { Dropdown } from "primereact/dropdown";
import { CONSTANTS } from "../../../../constants/callcentral.constants";
import { IonAlert } from "@ionic/react";
import { IonInput } from "@ionic/react";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import { Badge } from "primereact/badge";
import CustomColumn from "./components/CustomColumnPopup/CustomColumn";
import ExpandCard from "./components/ExpandedCard/ExpandCard";
import { utilService } from "../../../../services";
import { statusBoardService } from "../../StatusBoard.service";
import { statusBoardSocketService } from "../../StatusBoardSocketService";
import PrimaryMdPopup from "./components/PrimaryMdPopup/PrimaryMdPopup";
import classNames from "classnames/bind";
import { rolePermissionsService } from "../../../../services/rolePermissions.service";
import NursePopup from "./components/NursePopup/NursePopup";
import DNRPopup from "./components/DnrPopup/DnrPopup";
import { useToast } from "@agney/ir-toast";
import { useTranslation } from "react-i18next";

interface StatusBoardDataTableProps {
  unitDetails: any;
  statusBoardData: any;
  tableColumnUpdate?: any;
  updateTableData: () => void;
}

const StatusBoardDataTable: React.FC<StatusBoardDataTableProps> = (props) => {
  const currentTime = new Date();
const { t } = useTranslation("statusBoard");
  let [bedList, setBedList] = useState([]);
  let [dynamicColumns, setDynamicColumns] = useState([]);
  let [parsedTableData, setParsedTableData] = useState<any>([]);
  let [tableList, setTableList] = useState([]);
  const [expandedRows, setExpandedRows] = useState<any>(null);
  const [showCustomColumnPopup, setCustomColumnPopup] = useState(false);
  const [showExpandCard, setShowExpandCard] = useState(false);
  const [isMultiple, setIsMultiple] = useState(false);
  const [socketData, setSocketData]: any = useState();
  const [showAlert, setShowAlert] = useState(false);
  const rolePermissionData = rolePermissionsService.getRolePermissionsDetails();

  const [nurseModel, setNurseModel] = useState(false);
  const [primaryMdModel, setPrimaryMdModel] = useState(false);
  const [nurseData, setNurseData] = useState();
  const [rowData, setRowData] = useState();
  const [unitDetails, setUnitDetails] = useState();
  const [showDnrPopup, setShowDnrPopup] = useState(false);
  const [selectedBedForCarTeam, setSelectedBedForCarTeam] = useState<any>();
  const Toast = useToast();

  useLayoutEffect(() => {
    const subscription = statusBoardService.sbTableUpdated.subscribe((socketData: any) => {
      const expandedId = statusBoardService.selectedRowId;
      if (expandedId === "" || expandedId === undefined) {
        updateSbTableData(socketData);
      } else {
        const overlayView = document.getElementsByTagName("ion-alert")
          ? document.getElementsByTagName("ion-alert")
          : [];
        if (overlayView && overlayView.length === 0) {
          showConfirmation(socketData);
        } else {
          setIsMultiple(true);
        }
      }
    });
    
    // Module-level Subject: without this, every mount left a live
    // handler behind, so one update was handled once per visit.
    return () => subscription.unsubscribe();
  }, []);
  // select bed as notified through socket connection
  useLayoutEffect(() => {
    const subscription = statusBoardService.notifyStatusTable.subscribe((status) => {
      if (status && statusBoardService?.rowData) {
        onClickPatient(statusBoardService?.rowData);
      }
    });
    
    // Module-level Subject: without this, every mount left a live
    // handler behind, so one update was handled once per visit.
    return () => subscription.unsubscribe();
  }, []);

  // send care  team notification
  useLayoutEffect(() => {
    const subscription = statusBoardService.getNotifiedBedDetails.subscribe((bedId: any) => {
      if (bedId) {
        setIsNotifiedStatus(bedId);
      }
    });
    
    // Module-level Subject: without this, every mount left a live
    // handler behind, so one update was handled once per visit.
    return () => subscription.unsubscribe();
  }, []);

  // remove bed indication through socket connection
  useLayoutEffect(() => {
    const subscription = statusBoardService.removeIndication.subscribe((bedId: any) => {
      if (bedId) {
        removeBedIndication(bedId);
      }
    });
    
    // Module-level Subject: without this, every mount left a live
    // handler behind, so one update was handled once per visit.
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (props.tableColumnUpdate) {
      const bedList =
        props.unitDetails[0] && props.unitDetails[0].bedList
          ? props.unitDetails[0].bedList
          : [];
      setBedList(bedList);
      if (bedList && bedList.length > 0) {
        getDynamicColumns(bedList);
      }
    }
  }, [props.unitDetails]);

  const removeBedIndication = (bedId: any) => {
    let newFormattedTableList: any = [];
    const parsedTableList =
      parsedTableData && parsedTableData.length
        ? parsedTableData
        : statusBoardService.tableData
        ? statusBoardService.tableData
        : [];
    if (parsedTableList.length) {
      parsedTableList.forEach((item: any) => {
        if (item.id === bedId) {
          item["isNotified"] = false;
        } else {
          item["isNotified"] =
            item.isNotified !== undefined ? item.isNotified : false;
        }
        newFormattedTableList.push(item);
      });
      setParsedTableData(newFormattedTableList);
    }
  };

  useEffect(() => {
    if (
      !_.isEqual(
        bedList,
        props.unitDetails[0] && props.unitDetails[0].bedList
          ? props.unitDetails[0].bedList
          : []
      ) &&
      props.unitDetails &&
      props.unitDetails.length !== 0
    ) {
      const bedList =
        props.unitDetails[0] && props.unitDetails[0].bedList
          ? props.unitDetails[0].bedList
          : [];
      setBedList(bedList);
      if (bedList && bedList.length > 0) {
        getDynamicColumns(bedList);
      }
    }
  }, [props.unitDetails]);

  const showConfirmation = (socketData: any) => {
    setSocketData(socketData);
    setShowAlert(true);
  };

  const updateTableUI = () => {
    setExpandedRows(null);
    setShowExpandCard(false);
    statusBoardService.selectedRowId = "";
    const scrollBody = document
      .querySelector(".p-datatable-unfrozen-view")
      ?.querySelector(".p-datatable-scrollable-body-updated");
    if (scrollBody) {
      scrollBody.setAttribute("style", "overflow:auto");
    }
  };

  const updateSbTableData = (socketData: any) => {
    switch (socketData.socketType) {
      case CONSTANTS.SOCKET_TYPE.DISCHARGE:
      case CONSTANTS.SOCKET_TYPE.SWAP_TRANSFER:
        props.updateTableData();
        setIsMultiple(false);
        break;
      case CONSTANTS.SOCKET_TYPE.CUSTOM_COLUMNS:
      case CONSTANTS.SOCKET_TYPE.ADD_EDIT_PATIENT:
      case CONSTANTS.SOCKET_TYPE.PRIMARY_MD:
        props.updateTableData();
        setIsMultiple(false);
        break;
      case CONSTANTS.SOCKET_TYPE.NURSE_UPDATE:
        props.updateTableData();
        setIsMultiple(false);
        break;
      case CONSTANTS.SOCKET_TYPE.DATATABLE_ROW:
        updateTableDataThroughSocket(socketData);
        break;
    }
  };

  const updateTableDataThroughSocket = (socketMessage: any) => {
    const tableData = statusBoardService.tableData;
    if (tableData && tableData.length > 0) {
      const index = utilService.findObjectIndex(
        tableData,
        "id",
        socketMessage?.rowData?.id
      );
      if (index !== -1) {
        const newTableData = tableData;
        parsedTableData = newTableData;
        socketMessage.rowData.edit = newTableData[index].edit;
        newTableData[index] = socketMessage.rowData;
        setParsedTableData([]);
        setParsedTableData(newTableData);
        updateTableUI();
      }
    }
  };

  useEffect(() => {}, [expandedRows]);

  const params = {
    StatusBoardId: 1,
    page: 1,
    hour: currentTime.getHours(),
    minute: currentTime.getMinutes(),
    reg_code: utilService.getNetwork(),
  };

  const getDynamicColumns = (bedList: any) => {
    let parsedTableData: any = [];
    let frozenColumns: any = [];
    let scrollableColumns: any = [];

    bedList.forEach((element: any) => {
      const combinedObj = _.assign(
        {},
        element.frozen_columns,
        element.scrollable_columns
      );
      const idObj = {
        id: element.id,
        edit: element.edit,
        pid: element.pid,
        nurseid:
          element.frozen_columns &&
          element.frozen_columns.nurse &&
          element.frozen_columns.nurse.guid
            ? element.frozen_columns.nurse
            : "",
      };
      parsedTableData.push(_.cloneDeep(_.assign({}, combinedObj, idObj)));
      frozenColumns.push(
        _.cloneDeep(_.assign({}, element.frozen_columns, idObj))
      );
      scrollableColumns.push(
        _.cloneDeep(_.assign({}, element.scrollable_columns, idObj))
      );
    });
    setTypeFrozen(parsedTableData, frozenColumns);
    setParsedTableData(parsedTableData);
    statusBoardService.tableData = parsedTableData;
  };

  const setTypeFrozen = (parsedTableData: any, frozenColumns: any) => {
    let formattedList: any = [];
    for (const key in parsedTableData[0]) {
      if (
        parsedTableData[0].hasOwnProperty(key) &&
        key !== "id" &&
        key !== "edit" &&
        key !== "pid" &&
        key !== "nurseid"
      ) {
        const isFrozen = setFrozenKey(key, frozenColumns);
        var tableDataObject = Object.assign({}, parsedTableData[0][key]);
        tableDataObject.isFrozen = isFrozen;
        parsedTableData[0][key] = tableDataObject;
        formattedList.push(parsedTableData[0]);
      }
    }
    setParsedTableData(formattedList);
    setColumnsData(formattedList);
  };

  const setFrozenKey = (key: any, frozenColumns: any) => {
    var exists =
      frozenColumns.filter(function (type: any) {
        return type.hasOwnProperty(key);
      }).length > 0;
    return exists ? true : false;
  };

  const setColumnsData = (parsedTableData: any) => {
    let columnsNames: any = [];
    for (const key in parsedTableData[0]) {
      if (
        parsedTableData[0].hasOwnProperty(key) &&
        key !== "id" &&
        key !== "pid" &&
        key !== "edit" &&
        key !== "nurseid"
      ) {
        columnsNames.push({
          field: key,
          header: parsedTableData[0][key]
            ? parsedTableData[0][key]["title"]
            : "",
          width: parsedTableData[0][key]
            ? parsedTableData[0][key].width
            : "250px",
          frozen: parsedTableData[0][key]
            ? parsedTableData[0][key]["isFrozen"]
            : false,
          type:
            parsedTableData[0][key] && parsedTableData[0][key]["type"]
              ? parsedTableData[0][key]["type"]
              : "NONE",
        });
      }
    }
    // let frozenData = columnsNames.splice(0, 4);
    setTableList(columnsNames);
    setDynamicColumns(columnsNames);
  };
  const setFrozenColumns = (col: any, i: any) => {
    let column: any;
    switch (col.type) {
      case CONSTANTS.SBOARD_COLUMN_TYPE.CODE:
        column = setCodeColumn(col, i);
        break;
      case CONSTANTS.SBOARD_COLUMN_TYPE.TD:
        column = setTableData(col, i);
        break;
      case CONSTANTS.SBOARD_COLUMN_TYPE.BOOLEAN:
        break;
      case CONSTANTS.SBOARD_COLUMN_TYPE.DROPDOWN:
        break;
      case CONSTANTS.SBOARD_COLUMN_TYPE.TEXT:
        break;
      case CONSTANTS.SBOARD_COLUMN_TYPE.DROPDOWN_WITH_ICON:
        break;
    }

    if (col.field === "nurse") {
      column = setNurseField(col, i);
    }
    return column;
  };

  const setScrollableColumns = (col: any, i: any) => {
    let column: any;
    switch (col.type) {
      case CONSTANTS.SBOARD_COLUMN_TYPE.CODE:
        column = setCodeColumn(col, i);
        break;
      case CONSTANTS.SBOARD_COLUMN_TYPE.TD:
        column = setTableData(col, i);
        break;
      case CONSTANTS.SBOARD_COLUMN_TYPE.BOOLEAN:
        break;
      case CONSTANTS.SBOARD_COLUMN_TYPE.DROPDOWN:
        column = setDropdownField(col, i);
        break;
      case CONSTANTS.SBOARD_COLUMN_TYPE.TEXT:
        column = setIputField(col, i);
        break;
      case CONSTANTS.SBOARD_COLUMN_TYPE.DROPDOWN_WITH_ICON:
        column = setDropdownWithIconField(col, i);
        break;
    }
    if (col.field === "primarymd") {
      column = setPrimaryMdField(col, i);
    }
    return column;
  };

  const setNurseField = (col: any, i: any) => {
    let column: any;

    return (
      <Column
        key={i}
        field={col.field}
        header={col.header}
        headerStyle={{ width: col.width }}
        frozen={col.frozen}
        body={(rowData: any) => {
          if (
            rowData[col.field]["list_nurse"] &&
            rowData[col.field]["list_nurse"].length >= 1
          ) {
            let nurseList = rowData[col.field]["list_nurse"];
            column = setNurseListData(nurseList);
            return column;
          }
        }}
      />
    );
  };

  const setNurseListData = (nurseList: any) => {
    let moreNurseListLength: any =
      nurseList.length > 0 ? nurseList.length - 1 : 0;
    return (
      <div className="nurse-data">
        {nurseList && nurseList.length >= 1 ? (
          <div>
            {" "}
            {nurseList.map((nurseData: any, index: any) => {
              if (index == 0) {
                return (
                  <div key={index}>
                    <span className="nurse-name">
                      {nurseData?.first_name} {nurseData?.last_name}
                    </span>
                    <div className="nurse-shift">
                      <span className="nurse-speciality">
                        {" "}
                        {utilService.formatSpeciality(
                          nurseData?.shift_time[0]?.group?.speciality
                        )}
                      </span>
                      <span className="nurse-shift">
                        {" "}
                        {nurseData?.shift_time[0]?.start_time}{" "}
                        {nurseData?.shift_time[0]?.end_time ? "-" : ""}{" "}
                        {nurseData?.shift_time[0]?.end_time}
                      </span>
                    </div>
                  </div>
                );
              }
            })}
          </div>
        ) : (
          ""
        )}
        {nurseList && nurseList.length > 0 ? (
          <div className="nurse-badge-count">
            {moreNurseListLength && moreNurseListLength > 0 ? (
              <span
                className="nurse-count"
                onClick={() => openNurseModel(nurseList)}
              >
                <Badge value={"+" + "" + moreNurseListLength}></Badge>
              </span>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  const setCodeColumn = (col: any, i: any) => {
    if (col.field === "code") {
      return (
        <Column
          key={i}
          field={col.field}
          header={col.header}
          headerStyle={{ width: col.width }}
          frozen={col.frozen}
          body={(rowData: any) => {
            return dropDownBodyTemplate(col, rowData);
          }}
        />
      );
    }
  };

  const openNurseModel = (nurseList: any) => {
    setNurseModel(true);
    setNurseData(nurseList);
  };

  const openPrimaryMdModel = (rowData: any, unitDetails: any) => {
    setPrimaryMdModel(true);
    setRowData(rowData);
    setUnitDetails(unitDetails);
  };

  const setPrimaryMdField = (col: any, i: any) => {
    return (
      <Column
        key={i}
        field={col.field}
        header={col.header}
        headerStyle={{ width: col.width }}
        frozen={col.frozen}
        body={(rowData: any) => {
          return (
            <div
              className="primary-md-data"
              onClick={() => openPrimaryMdModel(rowData, props.unitDetails)}
            >
              <span className="primary-md-name">
                {" "}
                {rowData[col.field]?.first_name} {rowData[col.field]?.last_name}
              </span>
              {rowData[col.field]?.shift_time?.length > 0 && (
                <span className="primary-md-coverage">
                  {" "}
                  {rowData[col.field]?.shift_time?.length &&
                  rowData[col.field]?.coverage
                    ? rowData[col.field]?.first_name
                    : ""}
                </span>
              )}
              {rowData[col.field]?.shift_time?.length === 0 && (
                <span className="primary-md-coverage">
                  {" "}
                  {rowData[col.field]?.shift_time?.length === 0 ||
                  rowData[col.field]?.coverage
                    ? rowData[col.field]?.coverage?.shift_time[0]?.group
                        ?.user__first_name
                    : ""}
                </span>
              )}

              <div className="primary-md-shift-cont">
                {rowData[col.field]?.shift_time?.length > 0 && (
                  <span className="primary-md-speciality">
                    {" "}
                    {rowData[col.field]?.shift_time?.length &&
                    rowData[col.field]?.shift_time[0]?.group &&
                    rowData[col.field]?.shift_time[0]?.group?.speciality
                      ? utilService.formatSpeciality(
                          rowData[col.field]?.shift_time[0]?.group?.speciality
                        )
                      : ""}
                  </span>
                )}
                {rowData[col.field]?.shift_time?.length === 0 && (
                  <span className="primary-md-speciality ">
                    {" "}
                    {rowData[col.field]?.shift_time?.length === 0 &&
                    rowData[col.field]?.coverage?.shift_time[0]?.group
                      ?.speciality
                      ? utilService.formatSpeciality(
                          rowData[col.field]?.coverage?.shift_time[0]?.group
                            ?.speciality
                        )
                      : ""}
                  </span>
                )}
                {rowData[col.field]?.shift_time?.length > 0 && (
                  <span className="primary-md-shift">
                    {" "}
                    {rowData[col.field]?.shift_time?.length &&
                    rowData[col.field]?.shift_time[0]
                      ? rowData[col.field]?.shift_time[0]?.start_time
                      : ""}
                    {rowData[col.field]?.shift_time?.length &&
                    rowData[col.field]?.shift_time[0]
                      ? rowData[col.field]?.shift_time[0]?.end_time
                        ? " " + "-" + " "
                        : ""
                      : ""}{" "}
                    {rowData[col.field]?.shift_time?.length &&
                    rowData[col.field]?.shift_time[0]
                      ? rowData[col.field]?.shift_time[0]?.end_time
                      : ""}{" "}
                  </span>
                )}

                {rowData[col.field]?.shift_time?.length === 0 && (
                  <span className="primary-md-shift">
                    {" "}
                    {rowData[col.field]?.shift_time?.length === 0 &&
                    rowData[col.field].coverage
                      ? rowData[col.field]?.coverage?.shift_time[0]?.start_time
                      : ""}
                    {rowData[col.field]?.shift_time?.length === 0 &&
                    rowData[col.field].coverage
                      ? rowData[col.field]?.coverage?.shift_time[0]?.end_time
                        ? "-"
                        : ""
                      : ""}
                    {rowData[col.field]?.shift_time?.length === 0 &&
                    rowData[col.field].coverage
                      ? rowData[col.field]?.coverage?.shift_time[0]?.end_time
                      : ""}
                  </span>
                )}
              </div>
            </div>
          );
        }}
      />
    );
  };

  const setDropdownField = (col: any, i: any) => {
    return (
      <Column
        key={i}
        field={col.field}
        header={col.header}
        headerStyle={{ width: col.width }}
        frozen={col.frozen}
        body={(rowData: any) => {
          return dropDownBodyTemplate(col, rowData);
        }}
      />
    );
  };

  const setIputField = (col: any, i: any) => {
    return (
      <Column
        key={i}
        field={col.field}
        header={col.header}
        headerStyle={{ width: col.width }}
        frozen={col.frozen}
        body={(rowData: any) => {
          return inputFieldBodyTemplate(col, rowData);
        }}
      />
    );
  };

  const setDropdownWithIconField = (col: any, i: any) => {
    return (
      <Column
        key={i}
        field={col.field}
        header={col.header}
        headerStyle={{ width: col.width }}
        frozen={col.frozen}
        body={(rowData: any) => {
          return dropDownWithIconBodyTemplate(col, rowData);
        }}
      />
    );
  };

  const setTableData = (col: any, i: any) => {
    return (
      <Column
        key={i}
        field={col.field}
        header={col.header === "ROOM" ? "BED NO." : col.header}
        headerStyle={{ width: col.width }}
        frozen={col.frozen}
        body={(rowData: any) => {
          return col.header === "ROOM" ? (
            <div className="room-data">
              {rowData[col.field].value ? rowData[col.field].value : ""}
            </div>
          ) : rowData[col.field].value ? (
            <div
              className="patient-name"
              onClick={() => onClickPatient(rowData)}
            >
              <span className="patient-name-span">
                {rowData[col.field].value}
              </span>
              {rowData[col.field]?.message_count > 0 &&
                expandedRows === null && (
                  <span className="msg-count-wrapper">
                    {rowData[col.field]?.message_count}
                  </span>
                )}
            </div>
          ) : (
            ""
          );
        }}
      />
    );
  };

  const actionBodyTemplate = (rowData: any) => {
    if (rowData.edit) {
      return (
        <React.Fragment>
          <div className="icon-dropdown_arrow "></div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div className=" icon-hide_password"></div>
        </React.Fragment>
      );
    }
  };

  const onEditorValueChange = (
    rowData: any,
    field: any,
    dropdownvalue: any
  ) => {
    let newFormattedTableList: any = [];

    parsedTableData.forEach((item: any) => {
      if (item.id === rowData.id && item[field] !== undefined) {
        item[field].value = dropdownvalue;
      }
      newFormattedTableList.push(item);
    });
    setParsedTableData(newFormattedTableList);
    if (field === "code") {
      updateDNRValue(rowData, field, dropdownvalue);
    } else {
      updateTableValue(rowData, field, dropdownvalue);
    }
  };

  const dropDownBodyTemplate = (col: any, rowData: any) => {
    if (rowData[col.field] !== null && rowData[col.field] !== undefined) {
      return (
        <Dropdown
          className="drop-down-data"
          options={rowData[col.field].options}
          value={rowData[col.field].value}
          onChange={(e) => onEditorValueChange(rowData, col.field, e.value)}
        />
      );
    }
  };

  const inputFieldBodyTemplate = (col: any, rowData: any) => {
    return (
      <IonInput
        class="input-text-format"
        debounce={500}
        value={rowData[col.field]?.value}
        onIonBlur={(evt) => handleInputFieldChange(rowData, col.field, evt)}
        maxlength={50}
      ></IonInput>
    );
  };

  const selectedDropdownTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div>
          <span className={`icon-data ${option.icon}`}></span>
          <span>{option.label}</span>
        </div>
      );
    }
    return (
      <span>
        <span className={`icon-data ${option.icon}`}></span>
        {props.value.label}
      </span>
    );
  };

  const dropdownTemplate = (option: any) => {
    if (option) {
      return (
        <div>
          <span className={`icon-data ${option.icon}`}></span>
          <span>{option.label}</span>
        </div>
      );
    }
  };

  const dropDownWithIconBodyTemplate = (col: any, rowData: any) => {
    if (rowData[col.field] !== null && rowData[col.field] !== undefined) {
      return (
        <Dropdown
          className="drop-down-data"
          value={rowData[col.field].value}
          options={rowData[col.field].options}
          optionLabel="label"
          filterBy="label"
          placeholder={t("select")}
          valueTemplate={selectedDropdownTemplate}
          itemTemplate={dropdownTemplate}
          onChange={(e) => onEditorValueChange(rowData, col.field, e.value)}
        />
      );
    }
  };

  const dynamicColumn = tableList.map((col: any, i: any) => {
    let columns: any[] = [];
    if (col.frozen) {
      const frozencol = setFrozenColumns(col, i);
      columns.push(frozencol);
    }
    if (!col.frozen) {
      const scrollablecol = setScrollableColumns(col, i);
      columns.push(scrollablecol);
    }
    return columns;
  });

  const showCustomColumn = () => {
    if (checkForEmptyBeds() && !showExpandCard) {
      setCustomColumnPopup(checkForEmptyBeds());
    }
  };
  const checkForEmptyBeds = () => {
    const emptyBeds = _.filter(parsedTableData, { pid: " " });
    const isCustomColumnOpen =
      emptyBeds.length === parsedTableData.length ? false : true;
    return isCustomColumnOpen;
  };

  const updateTableDataWithCustomCol = (status: boolean) => {
    if (status) {
      props.updateTableData();
    }
    setCustomColumnPopup(false);
  };

  const updateTable = () => {
    setShowExpandCard(false);
    setExpandedRows(null);
    const scrollBody = document
      .querySelector(".p-datatable-unfrozen-view")
      ?.querySelector(".p-datatable-scrollable-body");
    scrollBody?.setAttribute("style", "overflow:auto");
    props.updateTableData();
  };

  const setEditClick = (data: any) => {
    setExpandedRows(data.data);
  };

  const onExpandCard = (rowData: any, event: any) => {
    if (expandedRows == null) {
      const expObject = {
        id: rowData.id,
      };
      setExpandedRows(expObject);
      statusBoardService.rowData = rowData;
      statusBoardService.statusBoardId = props.statusBoardData.StatusBoardId;
      statusBoardService.statusBoardData = props.unitDetails;
      statusBoardService.selectedRowId = rowData.id;
      clearSelectedCareTeam();
    } else {
      statusBoardService.selectedRowId = "";
      setExpandedRows(null);
      props.updateTableData();
    }
    setExapndCardPosition(rowData, event); // set the position of expanded card
  };

  const onEditClick = (rowData: any) => {
    if (
      rowData.edit ||
      (rowData?.pid === " " && rolePermissionData?.admitPatient) ||
      (rowData?.pid === " " &&
        rolePermissionData?.admitPatient &&
        rowData.edit === false)
    ) {
      return (
        <div
          id={`rowData-${rowData.id}`}
          className={classNames({
            "icon-edit": !showExpandCard ? true : false,
            "editable-row": true,
            "icon-close":
              showExpandCard &&
              expandedRows !== null &&
              expandedRows.id == rowData.id
                ? true
                : false,
          })}
          onClick={(e) => onExpandCard(rowData, e)}
        ></div>
      );
    } else if (
      (!rowData.edit && rowData?.pid !== " ") ||
      (rolePermissionData?.admitPatient === false && rowData?.pid === " ")
    ) {
      return <div className="icon-disabled"></div>;
    }
  };

  const setScriptStyleOnEditClick = (rowData: any, scrollBody: any) => {
    const expandWrap = document.querySelector(".expand-card");
    const rowIdDiv = document.getElementById("rowData-" + rowData.id);
    const topRequired = rowIdDiv?.getBoundingClientRect();
    if (topRequired) {
      if (navigator.userAgent.indexOf("Edge") > -1) {
        expandWrap?.setAttribute(
          "style",
          "position: fixed; left: 20px; top:" + (topRequired["top"] + 25) + "px"
        );
      } else if (navigator.userAgent.indexOf("Chrome") !== -1) {
        const value = isExtraLargeDevice() ? 15 : 25;
        expandWrap?.setAttribute(
          "style",
          "position: fixed; left: 20px; top:" +
            (topRequired["y"] - value) +
            "px"
        );
      } else {
        expandWrap?.parentElement?.setAttribute("style", "display:block");
        expandWrap?.setAttribute(
          "style",
          "position: absolute; left: 20px; top:" +
            (topRequired["y"] - 25) +
            "px"
        );
      }
      scrollBody.setAttribute("style", "overflow:auto");
    }
  };

  const setExapndCardPosition = (rowData: any, event: any) => {
    const scrollBody = document
      .querySelector(".p-datatable-frozen-view")
      ?.querySelector(".p-datatable-scrollable-body");
    if (expandedRows == null) {
      const clientY = rowData.id === undefined ? event.clientY : event.clientY;
      const scrollBodyDiv = document.getElementsByClassName(
        "p-datatable-scrollable-body"
      );
      const scrollElement: any = scrollBodyDiv[1];
      const scrollTop = scrollElement.scrollTop;

      if (window.navigator.userAgent.indexOf("Edge") > -1) {
        const edgeScrollTop =
          rowData.id === undefined && clientY > 350
            ? scrollTop + 45
            : scrollTop;
        scrollElement.scrollTop = edgeScrollTop;
      } else {
        const value = isExtraLargeDevice() ? 354 : 300;
        scrollElement.scrollTo({
          top: clientY + scrollElement.scrollTop - value,
          left: 0,
          behavior: "smooth",
        });
      }
      setTimeout(() => {
        if (!showExpandCard) {
          setShowExpandCard(true);
        }
        setScriptStyleOnEditClick(rowData, scrollBody);
      }, 1000);
    } else {
      setShowExpandCard(false);
      scrollBody?.setAttribute("style", "overflow:auto");
    }
  };

  const isExtraLargeDevice = () => {
    const windoWidth = window.matchMedia("(min-width: 2560px)");
    return windoWidth.matches;
  };

  const handleInputFieldChange = (rowData: any, field: any, current: any) => {
    let newFormattedTableList: any = [];
    parsedTableData.forEach((item: any) => {
      if (item.id === rowData.id && item[field] !== undefined) {
        item[field].value = current?.target?.value;
      }
      newFormattedTableList.push(item);
    });
    setParsedTableData(newFormattedTableList);
    updateTableValue(rowData, field, current?.target?.value);
  };

  // update table values upon its change
  const updateTableValue = async (
    rowData: any,
    field: any,
    dropdownvalue: any
  ) => {
    const params = getTableValueUpdateParams(rowData, field, dropdownvalue);
    const respResult: any = await statusBoardService.updateTableData(params);
    if (respResult.isSuccess) {
      //socket connection
      sendSocketData(rowData.id);
    } else {
    }
  };
  const updateDNRValue = async (
    rowData: any,
    field: any,
    dropdownvalue: any
  ) => {
    const params = getTableValueUpdateParams(rowData, field, dropdownvalue);
    const respResult: any = await statusBoardService.updateDNR(params);
    if (respResult.isSuccess) {
      //socket connection
      sendSocketData(rowData.id);
    } else {
    }
  };

  const sendSocketData = (id: any) => {
    const index = utilService.findObjectIndex(parsedTableData, "id", id);
    if (index !== -1) {
      const socketParams: any = {
        rowData: parsedTableData[index],
        socketType: CONSTANTS.SOCKET_TYPE.DATATABLE_ROW,
        updatedUniqueId: statusBoardSocketService.uniqueID,
      };
      statusBoardSocketService.sendSbSocketParams(socketParams);
    }
  };

  const getTableValueUpdateParams = (
    rowData: any,
    field: any,
    dropdownvalue: any
  ) => {
    let value = dropdownvalue;
    let selectedId;
    if (parsedTableData && parsedTableData.length) {
      parsedTableData.forEach((item: any) => {
        if (item.id === rowData.id && item[field] !== undefined) {
          selectedId = item[field].id;
        }
      });
    }
    return {
      id: selectedId,
      value: value,
      reg_code: utilService.getNetwork(),
    };
  };
  // click on patient for care team notification
  const onClickPatient = (rowData: any) => {
    if (rowData && !rowData?.isNotified) {
      if (checkIsCareTeamSelected()) {
        setSelectedBedForCarTeam(rowData);
        if (isDNR(rowData)) {
          DNRUser();
        } else {
          sendNotificationToCareTeam(rowData);
        }
      }
    } else if (rowData && rowData?.isNotified) {
      const socketParams = {
        socketType: CONSTANTS.SOCKET_TYPE.CARE_TEAM_OFF,
        bedId: rowData.id,
        updatedUniqueId: statusBoardSocketService.uniqueID,
      };
      statusBoardSocketService.sendSbSocketParams(socketParams);
      setSelectedBedForCarTeam(undefined);
      removeBedIndication(rowData.id);
    }
  };

  const checkIsCareTeamSelected = () => {
    let isCareTeamSelected = false;
    isCareTeamSelected = statusBoardService.selectedCareTeam ? true : false;
    return isCareTeamSelected;
  };

  // check if paient code is DNR
  const isDNR = (rowData: any) => {
    let isDNR = false;
    isDNR = rowData.code && rowData.code.value === "Full" ? false : true;
    return isDNR;
  };

  // show confirmation for DNR code
  const DNRUser = () => {
    setShowDnrPopup(true);
  };

  // send notification to care team
  const sendNotificationToCareTeam = async (rowData: any) => {
    const currentTime = new Date();
    const params = {
      bedId: rowData?.id,
      careTeamId: statusBoardService.selectedCareTeam
        ? statusBoardService.selectedCareTeam.id
        : null,
      hour: currentTime.getHours(),
      minute: currentTime.getMinutes(),
      reg_code: utilService.getNetwork(),
    };
    const respResult: any = await statusBoardService.notifyCareTeam(params);
    if (respResult.isSuccess) {
      Toast.success(
  t("careTeamNotificationSuccess", {
    name: statusBoardService.selectedCareTeam?.name || "",
  })
);
      setIsNotifiedStatus(rowData?.id);
      clearSelectedCareTeam();
      const socketParams = {
        socketType: CONSTANTS.SOCKET_TYPE.CARE_TEAM_ON,
        bedId: rowData?.id,
        updatedUniqueId: statusBoardSocketService.uniqueID,
      };
      statusBoardSocketService.sendSbSocketParams(socketParams);
    } else {
    }
  };

  // set isNotified  key
  const setIsNotifiedStatus = (rowDataId: any) => {
    let newFormattedTableList: any = [];
    const parsedTableList =
      parsedTableData && parsedTableData.length
        ? parsedTableData
        : statusBoardService.tableData
        ? statusBoardService.tableData
        : [];
    if (parsedTableList.length) {
      parsedTableList.forEach((item: any) => {
        if (item.id === rowDataId) {
          item["isNotified"] = true;
        } else {
          item["isNotified"] =
            item.isNotified !== undefined ? item.isNotified : false;
        }
        newFormattedTableList.push(item);
      });
      setParsedTableData(newFormattedTableList);
    }
  };

  const setNoficationStatus = (status: boolean) => {
    if (status) {
      sendNotificationToCareTeam(selectedBedForCarTeam);
    } else {
      clearSelectedCareTeam();
    }
    setShowDnrPopup(false);
  };

  // clear if a care team is selected
  const clearSelectedCareTeam = () => {
    statusBoardService.deSelectCareTeam(true);
  };

  const rowClass = (data: any) => {
    return {
      "notified-row": data?.isNotified !== undefined && data.isNotified,
      "normal-row": data?.isNotified === undefined || !data.isNotified,
    };
  };

  const onColumnResizeEnd = (data: any) => {
    updateColumnSize(data);
  };

  const updateColumnSize = async (columnData: any) => {
    const params = {
      column_name: columnData.column.field,
      column_width: getColumnWidth(columnData),
      column_type: columnData.column.frozen ? 1 : 2,
      status_board_id: props.statusBoardData.StatusBoardId,
      guid: utilService.getLoggedUserGuid(),
    };
    if (columnData.element.clientWidth > 30) {
      const respResult: any = await statusBoardService.updateColumnSize(params);
    }
  };

  const getColumnWidth = (columnData: any) => {
    let width: any = "";
    if (columnData.column.frozen) {
      const factor = window.innerWidth / 50;
      width = `${columnData.element.clientWidth / factor}vw`;
    } else {
      width = `${columnData.element.clientWidth}px`;
    }
    return width;
  };

  const handleAlertConfirmation = () => {
    setExpandedRows(null);
    if (isMultiple) {
      props.updateTableData();
      updateTableUI();
    } else {
      updateSbTableData(socketData);
    }
    if (!_.isEmpty(socketData)) {
      if (
        socketData.socketType === CONSTANTS.SOCKET_TYPE.SWAP_TRANSFER ||
        socketData.socketType === CONSTANTS.SOCKET_TYPE.DISCHARGE ||
        socketData.socketType === CONSTANTS.SOCKET_TYPE.ADD_EDIT_PATIENT ||
        socketData.socketType === CONSTANTS.SOCKET_TYPE.PRIMARY_MD
      ) {
        setShowExpandCard(false);
      }
    }
  };

  // adding scroll bar if patient is empty
  useEffect(()=>{
    const scrollBody:any = document
    .querySelector(".p-datatable-frozen-view")
    ?.querySelector(".p-datatable-scrollable-body");
    // appending scroll bar to the left section if primary md column does not present
    if(tableList?.length<5){
      scrollBody?.setAttribute("style", "overflow:auto");
    }else{
      scrollBody?.removeAttribute("style", "overflow:auto");
    }
  },[tableList])

  // bedList is the set of beds configured for the unit -- it stays non-empty
  // even when every bed is vacant, since `pid: " "` (not an empty bedList) is
  // how the backend marks an unassigned bed. Without this check the table
  // still rendered a grid of columns with no patient data in it instead of
  // the empty state.
  const hasAssignedPatients =
    parsedTableData &&
    parsedTableData.length > 0 &&
    !parsedTableData.every((item: any) => item.pid === " ");

  return (
    <div className="status-board-table">
      {bedList && bedList.length > 0 && hasAssignedPatients && (
        <div>
          <div
            className=" add-column icon-add"
            onClick={showCustomColumn}
          ></div>
          {showCustomColumnPopup && rolePermissionData.addAdditionalColumn && (
            <CustomColumn
              showModal={showCustomColumnPopup}
              statusBoardData={props.statusBoardData}
              updateTableData={updateTableDataWithCustomCol}
            ></CustomColumn>
          )}
          <DataTable
            resizableColumns
            showGridlines
            onColumnResizeEnd={onColumnResizeEnd}
            rowClassName={rowClass}
            className="data-table-container"
            value={parsedTableData}
            scrollable
            frozenWidth="50vw"
            expandedRows={expandedRows}
            onRowToggle={(e: any) => setEditClick(e.data)}
            dataKey="id"
          >
            <Column
              expander
              className="edit-col "
             header={t("edit")}
              frozen
              headerStyle={{ width: "2.5vw" }}
              body={(rowData: any) => {
                return onEditClick(rowData);
              }}
            >
              {" "}
            </Column>
            {dynamicColumn}
          </DataTable>
          {showExpandCard && (
            <div className="expand-card">
              <ExpandCard updateTableData={updateTable}></ExpandCard>
            </div>
          )}
          <IonAlert
            isOpen={showAlert}
            onDidDismiss={() => setShowAlert(false)}
            cssClass=""
          header={t("datatableUpdateTitle")}
message={t("datatableUpdateMessage")}
            buttons={[
              {
               text: t("no"),
                role: "cancel",
                cssClass: "secondary",
                handler: () => {},
              },
              {
                text: t("yes"),
                handler: () => {
                  handleAlertConfirmation();
                },
              },
            ]}
          />
          <NursePopup
            showModal={nurseModel}
            onCancel={() => {
              setNurseModel(false);
            }}
            nurseData={nurseData}
          />
          <PrimaryMdPopup
            showModal={primaryMdModel}
            onCancel={() => {
              setPrimaryMdModel(false);
            }}
            primaryMdData={rowData}
            unitDetailsData={unitDetails}
          />

          <DNRPopup
            showModal={showDnrPopup}
            rowData={statusBoardService.rowData}
            selectedCareTeamDetails={statusBoardService.selectedCareTeam}
            onCancel={setNoficationStatus}
          ></DNRPopup>
        </div>
      )}

      {(!bedList || bedList.length === 0 || !hasAssignedPatients) && (
        <div className="no-results">
          <span className="icon-no_bed no-results-icon"></span>
          <div className="no-results-text">
            {bedList && bedList.length > 0 ? t("noPatientsAssigned") : t("noRooms")}
          </div>
        </div>
      )}
    </div>
  );
};

export default StatusBoardDataTable;
